


























































import { defineComponent, type PropType } from "vue-demi";
import getValueForProp from "../../../helper/getValueForProp";
import type { PageData } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGBanner",
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  computed: {
    link() {
      const value = getValueForProp("bannerLink", this.data.template.prop);
      if (!value) return;
      const hasHost = /^(https?:\/\/[^\s/]+)/.test(value);
      return hasHost
        ? { tag: "a", value: value }
        : { tag: "GGLink", value: value };
    },
    desktopBanner() {
      return getValueForProp("bannerImageDesktop", this.data.template.prop);
    },
    mobileBanner() {
      return getValueForProp("bannerImageMobile", this.data.template.prop);
    },
    backgroundColor() {
      return getValueForProp("bannerBackgroundColor", this.data.template.prop);
    },
    mobileMaxHeight() {
      return `${getValueForProp(
        "bannerMobileMaxHeight",
        this.data.template.prop
      )}px`;
    },
    desktopMaxHeight() {
      return `${getValueForProp(
        "bannerDesktopMaxHeight",
        this.data.template.prop
      )}px`;
    },
  },
});
